import React, { useState, useMemo, useContext } from 'react';
import { FakturaattestWrapperContext } from '../Contexts/FakturaattestWrapperContext';
import ReservForDialog from './ReservForDialog';
import {
  ReservForQuery,
  ReservForQueryVariables,
} from '../../../ObjektVyer/Attestant/Components/ReservFor/Queries/_QueryTypes/ReservForQuery';
import query from '../../../ObjektVyer/Attestant/Components/ReservFor/Queries/ReservFor.gql';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { LoginStateContext } from '../../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import sysQuery from '../../../ObjektVyer/FakturaDel/Queries/LRSysOptionQuery/LRSysOptionQuery.gql';
import {
  LRSysOptionsQuery,
  LRSysOptionsQueryVariables,
} from '../../../ObjektVyer/FakturaDel/Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';
import mergeSort, { stringCompare } from '../../../../../../Utils/mergeSort';
import {
  LR_KVITTERA_ENDAST_RIKTADE,
  LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS,
  LR_USE_KVITTERING,
} from '../../../ObjektVyer/FakturaDel/Consts/FakturaDelSysoptionConsts';

interface IProps {
  attestantID: string;
}

const FakturaattestProviderWrapper: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const loginStateContext = useContext(LoginStateContext);
  const [openReservDialog, setOpenReservDialog] = useState(false);

  const dateString = new Date().toLocaleDateString('sv-SE');

  const { data, loading, refetch } = useQuery<
    ReservForQuery,
    ReservForQueryVariables
  >(query, {
    variables: {
      dbName: activeDatabase ?? '',
      routineID: 17001,
      userSign: loginStateContext.sign ?? '',
      date: dateString,
    },

    skip: !activeDatabase || !loginStateContext.sign,
  });

  const sysOptionQuery = useQuery<
    LRSysOptionsQuery,
    LRSysOptionsQueryVariables
  >(sysQuery, {
    variables: {
      dbName: activeDatabase ?? '',
      optionNames: [
        { value: 'LR_FLERA_ATTESTANTER' },
        { value: 'LR_REQUIRE_MOTKODBEH' },
        { value: 'LR_USE_SNABBREG' },
        {
          value: 'LR_LOGG_PREV_NEXT_IMAGE_ERROR',
        },
        {
          value: LR_USE_KVITTERING,
        },
        {
          value: LR_KVITTERA_ENDAST_RIKTADE,
        },
        {
          value: LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS,
        },
      ],
      routine: 17001,
    },
    skip: !activeDatabase,
  });

  const sysOptions = sysOptionQuery.data?.db?.SYSOptions_All;

  const sysMoms = sysOptionQuery.data?.db?.SYSMoms_All;

  const sysPrisbasbelopp = sysOptionQuery.data?.db?.SYSPrisbasbelopp_All;

  const unsortedreservForData = data?.db?.LRAttestrattReserv_All;

  const reservForData = mergeSort(unsortedreservForData ?? [], (a, b) =>
    stringCompare(
      a._Associations?.Attestratt?._Associations?.Attestant?.BENAMNING ?? '',
      b._Associations?.Attestratt?._Associations?.Attestant?.BENAMNING ?? ''
    )
  );

  const reservForKodbehorigheter = data?.reservForKodbehorigheter;

  const value = useMemo(
    () => ({
      loading,
      openReservDialog,
      refetch,
      reservForData,
      reservForKodbehorigheter,
      setOpenReservDialog,
      sysOptions,
      sysMoms,
      sysPrisbasbelopp,
    }),
    [
      loading,
      openReservDialog,
      refetch,
      reservForData,
      reservForKodbehorigheter,
      setOpenReservDialog,
      sysOptions,
      sysMoms,
      sysPrisbasbelopp,
    ]
  );

  return (
    <FakturaattestWrapperContext.Provider value={value}>
      {props.children}

      {openReservDialog && <ReservForDialog attestantID={props.attestantID} />}
    </FakturaattestWrapperContext.Provider>
  );
};

export default FakturaattestProviderWrapper;
